import { Heart, Eye } from "lucide-react";
import { useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { useSettings } from "../context/SettingsContext";
import MenuTags from "./MenuTags";

const MenuItemListView = ({ items, onView, selectedCatId }) => {
  const user = useSelector((state) => state.auth.user);
  const [favorites, setFavorites] = useState([]);
const { settings } = useSettings();

  useEffect(() => {
    if (user?.id) {
      axios
        .get(`${window.BASE_API_URL}getuserfav/${user.id}`)
        .then((res) => setFavorites(res.data.map((f) => f.menu_id)))
        .catch(() => {});
    }
  }, [user]);

  const toggleFav = async (id) => {
    if (!user) return toast.warn("Please login to add favorites");

    const isFav = favorites.includes(id);
    const url = isFav ? "remove-favorite" : "add-favorite";

    await axios.post(`${window.BASE_API_URL}${url}`, {
      id,
      user_id: user.id,
      selectedCatId,
    });

    setFavorites((prev) =>
      isFav ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };
const isMobile = window.innerWidth < 768;
  return (
    <div className="space-y-4 p-4">
      {items.map((item) => (
        <div
          key={item.id}
          className="flex items-center bg-white rounded-xl shadow-sm hover:shadow-md transition p-4"
        >
          {/* Image */}
            {!isMobile && (
    <img
      src={item.image}
      alt={item.name}
      className="w-24 h-24 object-cover rounded-md"
    />
  )}


          {/* Content */}
          <div className="flex-1 ml-4">
          <h3
  className="text-lg font-bold"
  style={{ color: settings?.cart_title_color || "#111827" }} // fallback dark
>
  {item.name} 
</h3>
<MenuTags tags={item.tags} />
            <p className="text-gray-500 text-sm line-clamp-2">
              {item.description}
            </p>

            <div className="flex items-center justify-between mt-3">
              <span className="text-lg font-semibold">
                {localStorage.getItem("currency")} {item.price.toFixed(2)}
              </span>

              <div className="flex items-center gap-3">
                {/* Favorite */}
                {user && (
                  <button
                    onClick={() => toggleFav(item.id)}
                    className="p-2 rounded-full bg-gray-100 hover:bg-gray-200"
                  >
                    <Heart
                      size={18}
                      className={
                        favorites.includes(item.id)
                          ? "text-red-500 fill-red-500"
                          : "text-gray-500"
                      }
                    />
                  </button>
                )}

                {/* View Button */}
                <button
                  onClick={() => onView(item.id)}
                  className="flex items-center gap-2 px-4 py-2 rounded-full bg-black text-white text-sm hover:scale-105 transition"
                  style={{
  background: settings?.cart_btn_color || "#000000ff",
   color: settings?.cart_btn_text_color || "#ffffff",
}}
onMouseEnter={(e) => {
  e.currentTarget.style.background =
    settings?.cart_btn_hover || "#f59e0b";
}}
onMouseLeave={(e) => {
  e.currentTarget.style.background =
    settings?.cart_btn_color || "#ffffff";
}}
                >
                  View <Eye size={16} />
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MenuItemListView;
